import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const navItems = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/group-spanking', label: 'Group Spanking' },
  { to: '/real-strapping', label: 'Real Strapping' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/testimonials', label: 'Testimonials' },
  { to: '/faq', label: 'FAQ' },
  { to: '/survey', label: 'Survey' },
  { to: '/contact', label: 'Contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur border-b border-neutral-200 shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className={`font-serif text-xl tracking-wide ${scrolled ? 'text-neutral-900' : 'text-white'}`}>
          Real<span className="font-semibold">OTK</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors duration-200 hover:opacity-80 ${
                  scrolled ? 'text-neutral-800' : 'text-white'
                } ${isActive ? 'underline underline-offset-8 decoration-1' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link to="/session-request">
            <Button
              className={`rounded-none px-6 h-10 text-sm tracking-wider ${
                scrolled
                  ? 'bg-neutral-900 text-white hover:bg-neutral-700'
                  : 'bg-white text-neutral-900 hover:bg-neutral-100'
              }`}
            >
              Session Request
            </Button>
          </Link>
        </nav>

        <button
          className={`md:hidden ${scrolled ? 'text-neutral-900' : 'text-white'}`}
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-neutral-200 px-6 py-4 space-y-3">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block text-neutral-800 py-2 border-b border-neutral-100 ${isActive ? 'font-semibold' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link to="/session-request" onClick={() => setOpen(false)}>
            <Button className="w-full mt-2 rounded-none bg-neutral-900 text-white hover:bg-neutral-700">
              Session Request
            </Button>
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
